// extracted by mini-css-extract-plugin
module.exports = {"SaveChangesBar":"SaveChangesBar_SaveChangesBar__1Gbaj","unsavedChanges":"SaveChangesBar_unsavedChanges__PP4w3","buttonGroup":"SaveChangesBar_buttonGroup__3-oYy"};